// extracted by mini-css-extract-plugin
export var pOutput = "output-module--p-output--10sQ_";
export var visible = "output-module--visible--11KvN";
export var subcopyBefore = "output-module--subcopy-before--1bNCM";
export var subcopyAfter = "output-module--subcopy-after--2gwVr";
export var oOutputProcess = "output-module--o-output-process--2LUxh";
export var outputProcess = "output-module--output-process--HOTdp";
export var standby = "output-module--standby--33r-_";
export var lContent__inner = "output-module--l-content__inner--3BtLz";
export var single = "output-module--single--3hfj0";
export var extra = "output-module--extra--1LWtL";
export var oOutput = "output-module--o-output--mczyD";
export var icon = "output-module--icon--1z1td";